/* eslint-disable max-statements */
import mobileEventsAU from "./au.mobile-events";
import inhouseMobileEventsAU from "./au.mobile-events-in-house-finance";
import desktopEventsAU, {DESKTOP_EVENT_CATEGORY} from "./au.desktop-events";
import commonEventsAU from "./ga-common-events.js";
import mobileCleverTapEventsAU from "./au.desktop-clevertap";
import desktopCleverTapEventsAU from "./au.desktop-clevertap";
import { getDeviceType } from "./c2c-tracking-params";
import { NUMBER } from "../constants/app-constants";
import pageSectionViewd from "./page-section-viewd";
import reMarketingEvents from "./marketing-page-events";
import fbEvents from "./fb-events";
import { AU_FILTER_EVENT } from "./au.mobile-filter-events.js";

const sendEvent = (data) => {
    if (typeof window !== "undefined" && window.dataLayer) {
        window.dataLayer.push({ ...data, ums_user_id: window.__ums_user_id || "" });
    }
};

export const trackCustomEvents = ({ platformEvents, category }, extras) => {
    const data = { ...extras, ...platformEvents[category] };
    sendEvent(data);
};

export const trackMobileCustomEventsAU = (category, extras = {eventLabel: "NA"}) => {
    if (typeof window !== "undefined") {
        window.setTimeout(() => {
            trackCustomEvents(
                {
                    platformEvents: {...mobileEventsAU, ...inhouseMobileEventsAU, ...pageSectionViewd, ...fbEvents, AU_FILTER_EVENT },
                    category
                },
                extras
            );
        }, 0);
    }
};

export const trackDesktopCustomEventsAU = (category, extras = {}) => {
    if (typeof window !== "undefined") {
        window.setTimeout(() => {
            trackCustomEvents({
                platformEvents: {...desktopEventsAU, ...inhouseMobileEventsAU, ...pageSectionViewd, ...DESKTOP_EVENT_CATEGORY, ...fbEvents},
                category
            }, extras);
        }, 0);
    }
};

export const trackCommonCustomEventsAU = (category, extras = {}) => {
    trackCustomEvents({
        platformEvents: {...commonEventsAU },
        category
    }, extras);
};

// Events fired before loadClevertap() runs (e.g. page-load effects on a hard refresh) are queued here;
// the CleverTap SDK replays the queued array once it loads
const getCleverTapQueue = () => {
    if (typeof window === "undefined") {
        return null;
    }
    window.clevertap = window.clevertap || {};
    window.clevertap.event = window.clevertap.event || [];
    return window.clevertap;
};

export const desktopCleverTapEvent = (eventName, data = {}, { userAgent = false } = {}) => {
    data = userAgent ? {...data, Device_type: getDeviceType() } : {...data};
    const clevertap = getCleverTapQueue();
    if (clevertap) {
        Object.keys(data).forEach(key => data[key] === undefined && delete data[key]);
        clevertap.event.push(desktopCleverTapEventsAU[eventName], data);
    }
};

export const mobileCleverTapEvent = (eventName, data = {}, { userAgent = false } = {}) => {
    data = userAgent ? {...data, Device_type: getDeviceType() } : {...data};
    const clevertap = getCleverTapQueue();
    if (clevertap) {
        Object.keys(data).forEach(key => data[key] === undefined && delete data[key]);
        clevertap.event.push(mobileCleverTapEventsAU[eventName], data);
    }
};

const CLEVERTAP_ORDER_EVENTS_KEY = "ct_order_events";

// Returns true only the first time an event is seen for an orderId in this browser
export const isFirstCleverTapOrderEvent = (eventName, orderId) => {
    if (!orderId || typeof window === "undefined") {
        return true;
    }
    const eventKey = `${eventName}_${orderId}`;
    try {
        const firedEvents = JSON.parse(window.localStorage.getItem(CLEVERTAP_ORDER_EVENTS_KEY)) || [];
        if (firedEvents.includes(eventKey)) {
            return false;
        }
        window.localStorage.setItem(CLEVERTAP_ORDER_EVENTS_KEY, JSON.stringify([...firedEvents, eventKey].slice(-NUMBER.FIFTY)));
    } catch (e) {
        return true;
    }
    return true;
};

export const cleverTapLogin = ({fullName, email, mobile, whatsappOptIn = true}) => {
    if (window.clevertap &&  window.clevertap.onUserLogin) {
        const profileData =  {"Site": {
            "Name": fullName,
            "Email": email,
            "Identity": email,
            "Phone": `+61${mobile}`,
            "MSG-email": true,
            "MSG-push": true,
            "MSG-sms": true,
            "MSG-whatsapp": whatsappOptIn ? true : false
        }};
        window.clevertap.onUserLogin.push(profileData);
        window.clevertap.profile.push(profileData);
    }
};

export const updateCleverTapProfile = ({fullName, email, mobile, whatsappOptIn = false}) => {
    if (window.clevertap && window.clevertap.profile) {
        const profileData =  {"Site": {
            "Name": fullName,
            "Email": email,
            "Identity": email,
            "Phone": `+61${mobile}`,
            "MSG-whatsapp": whatsappOptIn ? true : false
        }};
        window.clevertap.profile.push(profileData);
    }
};

export const clevertapLogout = () => {
    window.clevertap.logout();
};

export const showSiteControlWidget = (id) => {
    if (window && window.gsc) {
        window.gsc("show", id);
    }
};

export const trackCustomReMarketingEvents = (category, tagParams) => {
    const events = {...reMarketingEvents};
    const data = { ...events[category], google_tag_params: {...events[category].google_tag_params, ...tagParams} };
    sendEvent(data);
};

export const sendCustomGaEvents = (data = {}) => {
    sendEvent(data);
};

export const clevertapUserProperties = (clevertapUserPropertiesData) => {
    if (window !== "undefined" && window?.clevertap?.profile) {
        window.clevertap.profile.push({"Site": {...clevertapUserPropertiesData}});
    }
};
